<template>
    <svg xmlns="http://www.w3.org/2000/svg" class="e3-svg" :width="Number(size)" :height="Number(size)" viewBox="0 0 24 24">
        <path fill="currentColor" d="M14 13v4h-4v-4H7l5-5 5 5m2.35-2.97A7.49 7.49 0 0012 4C9.11 4 6.6 5.64 5.35 8.03A6.004 6.004 0 000 14a6 6 0 006 6h13a5 5 0 005-5c0-2.64-2.05-4.78-4.65-4.97z"/>
    </svg>
</template>

<script>
export default {
    name: 'CloudUploadIcon',
    props: {
        size: {
            type: [String, Number],
            default: 24
        }
    }
};
</script>
